import { safePrune } from "PFCore/helpers/safe_prune";

interface DescriptionProps {
  description: string;
  descriptionLength?: number;
}

export const Description = ({ description, descriptionLength = 140 }: DescriptionProps) => (
  <div>{safePrune(description, descriptionLength)}</div>
);
